<template>
    <div>
        <div v-if="error" class="row">
            <div class="col">
                <div class="alert alert-danger" role="alert">
                    {{ error }}
                    <button type="button" class="close" data-dismiss="alert" aria-label="Close" @click="error == null">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
            </div>
        </div>

        <div v-if="spinner" class="text-center">
            <div class="spinner-border text-primary" role="status">
                <span class="sr-only">Loading...</span>
            </div>
        </div>
        <div v-else>
            <div v-for="trainee in trainees" class="row">
                <div class="col-10">
                    {{ trainee.first_name }} {{ trainee.last_name }}, {{ trainee.county }} County
                    <span v-if="trainee.facility">, {{ trainee.facility }}</span>
                    <span v-if="trainee.other_agency">, {{ trainee.other_agency }}</span>
                    <span v-if="trainee.pre_test_score">, {{ trainee.pre_test_score }}</span>
                    <span v-if="trainee.post_test_score">, {{ trainee.post_test_score }}</span>
                    <span v-if="trainee.notes">, {{ trainee.notes }}</span>
                </div>
                <div class="col">
                    <i class="fas fa-trash-alt" style="color: red;" @click="deleteTrainee(trainee.id)" title="Delete"></i>
                </div>
            </div>
        </div>

        <hr v-if="trainees">

        <div v-if="validationErrors.length" id="validation_errors" class="row">
            <div class="col alert alert-danger" role="alert">
                The following required fields are missing:
                <ul>
                    <li v-for="error in validationErrors">{{ error }}</li>
                </ul>
            </div>
        </div>
        <div class="row align-items-center">
            <div class="col-2 text-right">
                <span style="color:red; font-size:1.2em;">*</span>
                First name:
            </div>
            <div class="col-4">
                <input type="text" class="form-control" v-model="newTrainee.first_name">
            </div>
            <div class="col-2 text-right">
                <span style="color:red; font-size:1.2em;">*</span>
                Last name:
            </div>
            <div class="col-4">
                <input type="text" class="form-control" v-model="newTrainee.last_name">
            </div>
        </div>
        <div v-if="encounterType == 'nfsEncounter'" class="row my-3 align-items-center">
            <label class="col-2 text-right">
                <span style="color:red; font-size:1.2em;">*</span>
                County:
            </label>
            <div class="col-4 input-group">
                <select name="county" class="form-control" v-model="newTrainee.county_id" @change="loadFacilities">
                    <option v-for="county in counties" :value="county.id">
                        {{ county.name }}
                    </option>
                </select>
            </div>
        </div>
        <div v-if="encounterType == 'nfsEncounter'" class="row my-3 align-items-center">
            <label class="col-2 text-right">
                Facility:
            </label>
            <div class="col-10 input-group">
                <select name="facility" class="form-control" v-model="newTrainee.facility_id">
                    <option v-for="facility in facilities" :value="facility.facility_id">
                        {{ facility.facility_name }}
                    </option>
                </select>
            </div>
        </div>
        <div class="row my-3 align-items-center">
            <div class="col-4 text-right">
                Other (agency, partnership, etc.):
            </div>
            <div class="col-8">
                <input type="text" class="form-control" v-model="newTrainee.other_agency">
            </div>
        </div>
        <div class="row align-items-center">
            <div class="col-2 text-right">
                Pre-test score
            </div>
            <div class="col-4">
                <input type="text" class="form-control" v-model="newTrainee.pre_test_score">
            </div>
            <div class="col-2 text-right">
                Post-test score
            </div>
            <div class="col-4">
                <input type="text" class="form-control" v-model="newTrainee.post_test_score">
            </div>
        </div>
        <div class="row my-3">
            <div class="col-2 text-right">
                Notes:
            </div>
            <div class="col-10">
                <textarea class="form-control" v-model="newTrainee.notes"></textarea>
            </div>
        </div>
        <div class="row my-3">
            <div class="col offset-2">
                <span class="btn btn-primary" @click="saveNewTrainee()" title="Add trainee to roster">Add</span>
                <span class="ml-4" style="color:red; font-size:1.2em;">* required</span>
            </div>
        </div>
        <hr v-if="trainees">
    </div>
</template>

<style scoped>
i {
    cursor: pointer;
}
select.form-control {
    width:auto;
    display:inline-block;
}
</style>

<script>
    export default {
        name: "Training Roster",

        props: ['userId', 'encounterType', 'encounterId'],

        data() {
            return {
                counties: [], // [{county_id: county_name}, {county_id: county_name}, ...]
                facilities: [],
                newTrainee: {
                    first_name: null,
                    last_name: null,
                    county_id: null,
                    facility_id: null,
                    other_agency: null,
                    pre_test_score: null,
                    post_test_score: null,
                    notes: null
                },
                error: null,
                facilitiesByCounty: [], // [{county_id: [{facility_id: facility_name}, ...]}, {county_id: [{facility_id: facility_name}, ...]}]
                trainees: [],
                spinner: false,
                validationErrors: []
            }       
         },

        methods: {
            saveNewTrainee () {
                this.validationErrors = []
                if (!this.newTrainee.first_name) {
                    this.validationErrors.push("First name")
                }
                if (!this.newTrainee.last_name) {
                    this.validationErrors.push("Last name")
                }
                if (this.encounterType == 'nfsEncounter' && !this.newTrainee.county_id) {
                    this.validationErrors.push("County")
                }
                if (this.validationErrors.length) {
                    return
                }

                this.spinner = true
                this.newTrainee.user_id = this.userId
                this.newTrainee.encounter_type = this.encounterType
                this.newTrainee.encounter_id = this.encounterId
                
                axios.post('/api/trainees', this.newTrainee)
                .then(function (response) {
                    this.newTrainee = {}
                    this.facilities = []
                    this.getTrainees()
                }.bind(this))
                .catch(function (error) {
                    console.log(error)
                })
            },
            deleteTrainee (trainee_id) {
                this.spinner = true
                axios.delete('/api/trainees/'+ trainee_id)
                .then(function (response) {
                    this.getTrainees()
                }.bind(this))
                .catch(function (error) {
                    console.log(error)
                })
            },
            getTrainees () {
                axios.get('/api/trainees?encounter_type='+ this.encounterType +'&encounter_id='+ this.encounterId)
                    .then(function (response) {
                        this.trainees = response.data.data
                        this.spinner = false
                    }.bind(this))
                    .catch(function (error) {
                        console.log(error)
                    })
            },
            getFacilitiesByCounty () {
                axios.get('/api/facilities-by-county')
                .then(function (response) {
                    this.facilitiesByCounty = response.data
                }.bind(this))
                .catch(function (error) {
                    console.log(error)
                })
            },
            getCounties () {
                axios.get('/api/counties')
                .then(function (response) {
                    this.counties = response.data.data
                }.bind(this))
                .catch(function (error) {
                    console.log(error)
                })
            },
            loadFacilities (event) {
                this.facilities = this.facilitiesByCounty[event.target.value]
            }
        },

        mounted () {
            this.getCounties()
            this.getFacilitiesByCounty()
            this.getTrainees()
        }
    }
</script>
